import { render, staticRenderFns } from "./gain_token.vue?vue&type=template&id=3904670a&scoped=true&"
import script from "./gain_token.vue?vue&type=script&lang=js&"
export * from "./gain_token.vue?vue&type=script&lang=js&"
import style0 from "./gain_token.vue?vue&type=style&index=0&id=3904670a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904670a",
  null
  
)

export default component.exports